<form #currentForm="ngForm" (submit)="submitForm(currentForm.form.valid)" novalidate>
  <fieldset>
    <div class="form-group">
      <label>Setting Group</label>
      <select type="text" required placeholder="Setting Group" class="form-control" [(ngModel)]="setting_group_id" name="setting_group_id" #setting_group_id_field="ngModel" (change)="onSettingGroupSelect()">
        <option *ngFor="let settingGroup of settingGroups" [value]="settingGroup.id">{{ settingGroup.name }}</option>
      </select>
      <div class="alert alert-danger alert-padding-sm" *ngIf="fieldShowErrorMessage(setting_group_id_field)">{{ fieldBuildErrorMessage(setting_group_id_field, 'Setting Group') }}</div>
    </div>
    <div class="form-group">
      <label>Setting Type</label>
      <select type="text" required placeholder="Setting Type" class="form-control" [(ngModel)]="setting.setting_type_id" name="setting_type_id" #setting_type_id="ngModel" [disabled]="!setting_group_id">
        <option *ngFor="let settingType of settingTypes" [value]="settingType.id">{{ settingType.name }}</option>
      </select>
      <span class="help-block" *ngIf="!setting_group_id"> Select a setting group to get its setting types list </span>
      <div class="alert alert-danger alert-padding-sm" *ngIf="fieldShowErrorMessage(setting_type_id)">{{ fieldBuildErrorMessage(setting_type_id, 'Setting Type') }}</div>
    </div>
    <div class="form-group">
      <label>Value</label>
      <input type="text" required placeholder="Value" class="form-control" [(ngModel)]="setting.value" name="value" #value="ngModel" />
      <div class="alert alert-danger alert-padding-sm" *ngIf="fieldShowErrorMessage(value)">{{ fieldBuildErrorMessage(value, 'Value') }}</div>
    </div>
    <div class="form-group text-center">
      <button type="submit" [disabled]="formSubmitting" class="btn btn-primary">
        {{ setting.id ? 'Save' : 'Add' }}
      </button>
      &nbsp;
      <button type="button" (click)="this.formEvent.emit('Form Cancelled')" class="btn btn-secondary">Cancel</button>
    </div>
  </fieldset>
</form>
